import { FormBase } from 'core/components';

export default class LinkOrderLineForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'product',
					label: 'LINKORDERLINEVIEW.PRODUCT',
					rules: 'required',
				},
				{
					name: 'description',
					label: 'LINKORDERLINEVIEW.DESCRIPTION',
				},
			],
		};
	}
}
